import { Dropdown } from 'react-bootstrap';
import { Link, useHistory } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import { useState, React, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL, IMAGE_URL, IMAGE_URL_UPLOAD } from "@/config/serverApiConfig";




const Header2 = () => {
  
 const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem('user');
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (error) {
      console.error("Failed to parse user from localStorage:", error);
      return null;
    }
  });
  // useEffect(() => {
  //   setProfileImage(user.profileImage);
  //   setImg({
  //     srcurl: IMAGE_URL_UPLOAD + user.profileImage,
  //     alt: "Profile Picture",
  //   });
  //   user.block_status == true ? removeToken() : null;
  //   user.delete_status == true ? removeToken() : null;
  //   //setUser(localStorage.getItem('user'));
  // }, [user])
  useEffect(() => {
  if (user?.profileImage) {
    setProfileImage(user.profileImage);
    setImg({
      srcurl: IMAGE_URL_UPLOAD + user.profileImage,
      alt: "Profile Picture",
    });
  }

  if (user?.block_status) removeToken();
  if (user?.delete_status) removeToken();
}, [user]);
  
  
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const currentRoute = useHistory().location.pathname.toLowerCase();
  const history = useHistory();
  if (localStorage.getItem("token") === undefined || localStorage.getItem("token") === null) {
    history.push('/login');
  }

  const removeToken = () => { // export function from module 
    //localStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('fname');
    history.push('/login');
    //setToken(null);
  }
  let token = localStorage.getItem("token");
  let [fname, setFname] = useState('');



  useEffect(() => {
    let msg = "getting user by token";
    axios.post(`${API_BASE_URL}user/getUserById`,msg, {
      headers: {
        'Content-Type': 'multipart/form-data',
          'x-access-token': `${token}`
      }
    }
    )
      .then(res => {
        // console.log("res", res.data.decryptedUser);
        /* localStorage.setItem('fname', JSON.stringify(res.data.user.fname));
        setUser(res.data.user);
        setFname(res.data.user.fname); */

        localStorage.setItem('fname', JSON.stringify(res.data.decryptedUser.fname));
        setUser(res.data.decryptedUser);
        setFname(res.data.decryptedUser.fname);


      })
      .catch(err => {

      });
  }, []);
  
  const [profileImage, setProfileImage] = useState(user?.profileImage ?? '');

  const [{ alt, srcurl }, setImg] = useState({
    srcurl: user?.profileImage ? IMAGE_URL_UPLOAD + user.profileImage : '',
    alt: "Profile Picture",
  });

  useEffect(() => {
    if (user) {
      setImg({
        srcurl: IMAGE_URL_UPLOAD + user.profileImage,
        alt: "Profile Picture",
      });
    }
  }, [user]);;


// console.log("user", typeof(user.profileImage));
 
 

  // const fname = user.fname;
  return (
    <>
      <div className="top-space"></div>
      <nav className="p-0 navbar navbar-expand-lg navbar-light d-flex justify-content-center bg-white fixed-top pt-0">
        <div className="container-fluid w-100 p-0">
          <div className="logo_wrap dash_navbar-brand">
            <Link className="navbar-brand m-0" as={Link} to="/">
              <img className="site-logo" src="..\assets\images\logo.png" />{" "}
            </Link>
          </div>
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex  w-100 ps-5">
            <li className="nav-item">
              <Link
                className={
                  currentRoute.includes("/dashboard")
                    ? "nav-link active"
                    : "nav-link"
                }
                aria-current="page"
                as={Link}
                to="./dashboard"
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={
                  currentRoute.includes("/aboutus")
                    ? "nav-link active"
                    : "nav-link"
                }
                as={Link}
                to="/aboutus"
              >
                About Us
              </Link>
            </li>
            <li
              className="nav-item me-0"
              onClick={() => {
                setShow(true);
              }}
            >
              <Link
                className={
                  currentRoute.includes("#") ? "nav-link active" : "nav-link"
                }
                as={Link}
                to="#"
              >
                How It Works
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={
                  currentRoute.includes("/privacy-policy")
                    ? "nav-link active"
                    : "nav-link"
                }
                to="/privacy-policy"
              >
                Privacy Policy
              </Link>
            </li>
          </ul>
          <div className="user_menue">
            <Dropdown>
              <Dropdown.Toggle
                variant="success user_btn w-100"
                id="dropdown-basic"
              >
                <div className="btn_content">
                  <span className="user_img">
                    <img src={srcurl}></img>
                  </span>
                  <span className="user_name">{fname ? fname : ""}</span>
                </div>
                <span className="arrow">
                  <svg
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.38128 7.61872C6.72299 7.96043 7.27701 7.96043 7.61872 7.61872L13.1872 2.05025C13.5289 1.70854 13.5289 1.15452 13.1872 0.812816C12.8455 0.471107 12.2915 0.471107 11.9497 0.812816L7 5.76256L2.05025 0.812816C1.70854 0.471107 1.15452 0.471107 0.812816 0.812816C0.471107 1.15452 0.471107 1.70854 0.812816 2.05025L6.38128 7.61872ZM6.125 6V7H7.875V6H6.125Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <div className="slide_btn_content">
                  <span className="slide_user_img">
                    <img src="..\assets\images\user_avatar.png"></img>
                  </span>
                  <span className="slide_user_name">
                    {fname && fname ? fname : ""}
                  </span>
                </div>
                <Dropdown.Item as={Link} to="/updateprofile">
                  <svg
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_1_91)">
                      <path
                        d="M9.66529 0C9.31508 0.0788662 8.95079 0.123807 8.61654 0.243208C7.18097 0.755618 6.27306 1.74343 5.90501 3.12337C5.46279 4.77956 5.89046 6.24497 7.20444 7.44999C8.6034 8.73344 10.9023 8.85989 12.4416 7.73021C13.8706 6.67983 14.4494 5.27875 14.2025 3.60405C13.9861 2.13688 13.1589 1.03716 11.7323 0.379792C11.3591 0.20796 10.9276 0.146277 10.522 0.0356879C10.4629 0.019386 10.4009 0.0114554 10.3404 0H9.66529Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                      <path
                        d="M17.8837 18C17.8837 17.5004 17.9109 17.0082 17.879 16.5192C17.7297 14.2281 16.6876 12.3569 14.729 10.9915C12.3789 9.35289 9.78476 9.04227 7.06054 10.038C5.19119 10.7209 3.82134 11.9586 2.91905 13.6482C2.36041 14.6955 2.1116 15.8072 2.1055 16.9725C2.1055 17.3113 2.1055 17.6497 2.1055 18H17.8837Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_91">
                        <rect
                          width="20"
                          height="18"
                          fill="white"
                          transform="matrix(-1 0 0 1 20 0)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Profile
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/requesthistory">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_1_80)">
                      <path
                        d="M3.5708 10.0164C3.5708 6.47547 6.45818 3.58152 9.98661 3.58331C10.8354 3.58331 11.6759 3.75095 12.4597 4.07663C13.2436 4.4023 13.9554 4.87959 14.5543 5.48109C15.1532 6.0826 15.6274 6.79647 15.9497 7.58173C16.2719 8.36699 16.4359 9.20817 16.4322 10.057C16.4239 13.592 13.5317 16.471 9.99197 16.4668C6.45222 16.4627 3.5702 13.5747 3.5708 10.0164ZM10.7159 7.96985C10.7159 7.48564 10.7159 7.00083 10.7159 6.51602C10.7159 6.05805 10.4213 5.73544 10.0093 5.73126C9.58528 5.72709 9.28832 6.05089 9.28772 6.52258C9.28772 7.66334 9.28772 8.8041 9.28772 9.94427C9.28772 10.255 9.40281 10.4869 9.6628 10.6599C10.3396 11.1065 11.0111 11.5615 11.6873 12.0099C12.0707 12.264 12.4989 12.199 12.7303 11.8573C12.9688 11.5048 12.8668 11.0821 12.4745 10.8179C11.9437 10.4601 11.413 10.1023 10.8763 9.75464C10.8221 9.72523 10.7779 9.6804 10.7493 9.62584C10.7206 9.57127 10.7088 9.50942 10.7153 9.44813C10.7219 8.95438 10.7159 8.46182 10.7159 7.96985Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                      <path
                        d="M5.36344 2.86829C5.48986 2.86829 5.61628 2.86293 5.74211 2.86829C5.92678 2.87584 6.10137 2.95455 6.22931 3.08794C6.35726 3.22133 6.42863 3.39905 6.42847 3.58388C6.42979 3.76886 6.35852 3.94697 6.22996 4.07999C6.10141 4.213 5.92583 4.2903 5.74091 4.29529C5.01141 4.30523 4.28211 4.30523 3.55301 4.29529C3.4613 4.29522 3.37052 4.27697 3.2859 4.24161C3.20129 4.20624 3.12452 4.15446 3.06003 4.08925C2.99555 4.02405 2.94462 3.94671 2.9102 3.8617C2.87578 3.7767 2.85854 3.68572 2.85949 3.59402C2.85194 2.87128 2.85194 2.14834 2.85949 1.4252C2.85995 1.33194 2.87887 1.23971 2.91515 1.1538C2.95144 1.06789 3.00436 0.990014 3.07088 0.924658C3.1374 0.859302 3.2162 0.807758 3.30274 0.772999C3.38927 0.73824 3.48183 0.720953 3.57507 0.722135C3.75975 0.724365 3.93641 0.79791 4.0681 0.927386C4.1998 1.05686 4.27634 1.23224 4.28172 1.41685C4.28649 1.52776 4.28172 1.63987 4.28172 1.78776C4.35685 1.74483 4.41171 1.71739 4.46061 1.6834C10.3976 -2.29823 18.5445 1.1491 19.832 8.18569C20.8225 13.5979 17.3215 18.7847 11.9605 19.8533C6.83218 20.8748 1.7885 17.7662 0.366272 12.7112C0.131893 11.8707 0.00958258 11.0028 0.00251545 10.1303C-0.00285144 9.63952 0.283979 9.30856 0.714523 9.30797C1.13493 9.30797 1.41401 9.62938 1.43011 10.107C1.56011 13.5234 3.10279 16.0953 6.12077 17.6887C11.041 20.291 17.204 17.369 18.3925 11.9288C19.3973 7.3246 16.6226 2.81403 12.0679 1.69175C9.73865 1.11809 7.53882 1.48721 5.48628 2.73233C5.43858 2.76155 5.39385 2.79674 5.34734 2.82894L5.36344 2.86829Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_80">
                        <rect width="20" height="20.0489" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Request History
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/requestBusinesshistory">
                  <svg
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_251_45743)">
                      <path
                        d="M19.9995 17.6702C19.819 18.1105 19.4824 18.2373 19.0211 18.2363C12.9928 18.2275 6.96461 18.2252 0.93638 18.2294C0.806422 18.2349 0.676259 18.2256 0.548425 18.2015C0.200097 18.1189 -0.00195312 17.8185 -0.00195312 17.4041C-0.00195312 15.3533 -0.00195312 13.3026 -0.00195312 11.2521V11.0647C0.101763 11.1381 0.182484 11.1968 0.265163 11.253C0.851882 11.6489 1.54566 11.8558 2.25337 11.846C3.88738 11.846 5.5214 11.846 7.15541 11.846H7.40834C7.40834 12.0725 7.41176 12.279 7.40834 12.4854C7.40198 12.776 7.52918 12.979 7.78553 13.1146C8.41272 13.4448 9.03697 13.7799 9.66171 14.115C9.76338 14.1742 9.87893 14.2054 9.99658 14.2054C10.1142 14.2054 10.2298 14.1742 10.3315 14.115C10.9616 13.7775 11.5925 13.4409 12.2243 13.1053C12.4738 12.9732 12.5941 12.7706 12.5887 12.4883C12.5853 12.2819 12.5887 12.075 12.5887 11.844H12.8363C14.2947 11.844 15.7535 11.821 17.2109 11.8519C18.2305 11.8734 19.1791 11.7193 19.9995 11.0691V17.6702Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                      <path
                        d="M19.9995 8.72522C19.9648 8.85634 19.9364 8.98941 19.8948 9.1166C19.5974 10.0393 18.7799 10.6298 17.7794 10.6332C16.2369 10.6376 14.6939 10.6332 13.1513 10.6332H12.5912V10.0461C12.5912 9.89643 12.5946 9.74672 12.5912 9.59702C12.578 9.20564 12.3412 8.96886 11.9479 8.96397C11.4469 8.95712 10.9459 8.96397 10.4445 8.96397C9.66985 8.96397 8.89525 8.96397 8.12064 8.96397C7.64414 8.96397 7.41518 9.19341 7.41224 9.66992C7.41224 9.98155 7.41224 10.2927 7.41224 10.6342H7.19063C5.55661 10.6342 3.92277 10.6342 2.28908 10.6342C0.928545 10.6342 0.00244235 9.70465 0.00195312 8.33482C0.00195312 7.25428 0.00195312 6.17375 0.00195312 5.09322C0.00195312 4.53256 0.295488 4.23658 0.85614 4.23658C6.94895 4.23658 13.0416 4.23544 19.1341 4.23315C19.567 4.23315 19.8459 4.42249 20.0015 4.81533L19.9995 8.72522Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                      <path
                        d="M7.06388 3.01939H5.8457C5.8775 2.78945 5.90539 2.57273 5.93866 2.35698C6.00275 1.93967 6.05118 1.51893 6.13973 1.10652C6.26693 0.513088 6.82709 0.0488174 7.43617 0.0145717C7.76689 -0.00352963 8.09907 0.00185088 8.43077 0.00136166C9.73146 0.00136166 11.0325 0.00136166 12.3338 0.00136166C13.1513 0.00136166 13.7296 0.435796 13.8837 1.20339C14.0021 1.79486 14.0686 2.39661 14.1611 3.01352H12.938C12.87 2.54191 12.8 2.07421 12.7355 1.60553C12.6895 1.27237 12.6249 1.21072 12.2844 1.21072H7.71601C7.37698 1.21072 7.31289 1.27237 7.2669 1.60749C7.20233 2.07568 7.13237 2.54337 7.06388 3.01939Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                      <path
                        d="M8.62045 10.1851H11.3841V10.6562C11.3841 11.1117 11.3802 11.5676 11.3841 12.0231C11.3907 12.074 11.3801 12.1257 11.3541 12.17C11.328 12.2143 11.288 12.2487 11.2402 12.2677C10.8699 12.4565 10.5064 12.6591 10.1351 12.8469C10.094 12.8653 10.0496 12.8753 10.0045 12.8762C9.95948 12.8772 9.91471 12.869 9.87286 12.8523C9.49469 12.6645 9.12337 12.4609 8.75352 12.2584C8.69873 12.2281 8.62436 12.164 8.62339 12.1146C8.61605 11.4756 8.62045 10.8387 8.62045 10.1851Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_251_45743">
                        <rect width="20" height="18.2363" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  My Business
                </Dropdown.Item>
                {/* <Dropdown.Item to="#/action-1">
                  <svg
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_1_83)">
                      <path
                        d="M15.01 3.99671H14.6612C10.1672 3.99671 5.67339 3.99671 1.17982 3.99671C1.00103 4.00352 0.82228 3.9824 0.65001 3.93409C0.194724 3.78128 -0.055778 3.32286 0.011231 2.83314C0.0475502 2.61159 0.158407 2.40908 0.325466 2.2591C0.492525 2.10912 0.705776 2.02067 0.929943 2.00836C1.0314 2.0021 1.13285 2.00398 1.23493 2.00398H15.0125C15.0125 1.63574 15.0018 1.28692 15.0156 0.93935C15.0266 0.690635 15.1316 0.455361 15.3093 0.281014C15.487 0.106667 15.7243 0.00622902 15.9732 -2.83794e-05C16.2338 -0.0107119 16.4881 0.0825791 16.68 0.259328C16.8719 0.436077 16.9857 0.681809 16.9965 0.942481C17.0102 1.28441 16.9965 1.62697 16.9965 1.99083C17.1054 1.99584 17.1887 2.00273 17.2714 2.00273C17.835 2.00273 18.3986 2.00273 18.9623 2.00273C19.5754 2.00836 20.0031 2.42294 20.0019 3.00034C20.0006 3.57775 19.5716 3.98732 18.9566 3.99295C18.4018 3.99796 17.8469 3.99295 17.2921 3.99295H16.999C16.999 4.36244 17.0102 4.71127 16.999 5.05758C16.9876 5.30252 16.8854 5.53445 16.7123 5.70812C16.5392 5.8818 16.3076 5.98477 16.0627 5.99696C15.9318 6.00473 15.8006 5.98633 15.6768 5.94284C15.5531 5.89935 15.4392 5.83164 15.3419 5.74366C15.2446 5.65569 15.1658 5.54921 15.1101 5.43045C15.0544 5.31168 15.0229 5.18301 15.0175 5.05195C14.9993 4.71314 15.01 4.37121 15.01 3.99671Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                      <path
                        d="M9.0106 8.0054C9.0106 7.61211 8.99431 7.2539 9.01435 6.89631C9.04254 6.39092 9.49594 5.99638 10.012 6.00139C10.518 6.00703 10.9545 6.39906 10.9877 6.89631C11.0058 7.16873 10.9952 7.44302 10.9971 7.71607C10.9971 7.80061 10.9971 7.88516 10.9971 8.0054H11.2902C13.8064 8.0054 16.3229 8.0054 18.8396 8.0054C18.9868 7.99925 19.1342 8.01231 19.278 8.04423C19.7621 8.17511 20.0483 8.62727 19.99 9.14017C19.9611 9.37084 19.8504 9.58349 19.678 9.73952C19.5057 9.89556 19.2831 9.98464 19.0507 9.99062C18.5353 10.0038 18.0192 9.99625 17.5038 9.99625H10.9946C10.9946 10.3551 11.0033 10.6952 10.9946 11.0352C10.9897 11.2641 10.9052 11.4841 10.7558 11.6575C10.6063 11.8308 10.4011 11.9467 10.1754 11.9852C10.0386 12.0102 9.89801 12.0061 9.76289 11.973C9.62778 11.94 9.50116 11.8788 9.39132 11.7934C9.28149 11.708 9.19092 11.6004 9.12552 11.4777C9.06013 11.3549 9.0214 11.2197 9.01185 11.0809C8.99432 10.7321 9.00872 10.3814 9.00872 9.99563H8.71188C6.16512 9.99563 3.61732 9.99563 1.06847 9.99563C0.397127 9.99563 -0.0387441 9.5416 0.00384108 8.90658C0.0229056 8.67872 0.120939 8.46467 0.281014 8.30139C0.441089 8.13811 0.653157 8.03586 0.880594 8.01229C0.988936 8.00289 1.09915 8.00477 1.20812 8.00477H9.0106V8.0054Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                      <path
                        d="M16.9995 16.0001C16.9995 16.3471 17.0032 16.6514 16.9995 16.9558C16.992 17.5639 16.573 18.0029 16.005 18.0035C15.437 18.0041 15.0161 17.5651 15.0086 16.9577C15.0042 16.6533 15.0086 16.3489 15.0086 16.0001H14.7043C10.2028 16.0001 5.70104 16.0001 1.19912 16.0001C1.05094 16.0071 0.902447 15.9977 0.756358 15.9719C0.265376 15.8605 -0.0433631 15.3989 0.00861587 14.8779C0.0359307 14.647 0.144253 14.4333 0.314316 14.2749C0.484378 14.1164 0.705147 14.0234 0.937346 14.0124C1.0388 14.0067 1.14088 14.0086 1.24233 14.0086H15.0105C15.0105 13.6423 14.9999 13.301 15.0105 12.9609C15.0155 12.8061 15.0568 12.6547 15.1311 12.5187C15.2053 12.3828 15.3103 12.2661 15.4378 12.1782C15.5653 12.0902 15.7116 12.0334 15.8651 12.0123C16.0185 11.9912 16.1747 12.0064 16.3213 12.0566C16.512 12.1191 16.6788 12.2388 16.7991 12.3995C16.9193 12.5602 16.9871 12.754 16.9932 12.9546C17.0045 13.2953 16.9932 13.6373 16.9932 14.0086H17.3915C17.9307 14.0086 18.4699 14.0017 19.0091 14.0086C19.1404 14.0071 19.2706 14.0322 19.392 14.0822C19.5133 14.1322 19.6234 14.2062 19.7155 14.2998C19.8076 14.3933 19.8798 14.5045 19.9279 14.6267C19.9761 14.7488 19.999 14.8794 19.9955 15.0106C19.9966 15.1399 19.9721 15.2682 19.9232 15.3879C19.8743 15.5077 19.8021 15.6165 19.7108 15.708C19.6195 15.7996 19.5109 15.8721 19.3912 15.9212C19.2716 15.9704 19.1435 15.9953 19.0141 15.9945C18.4361 16.0051 17.8574 15.9976 17.2788 15.9982L16.9995 16.0001Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_83">
                        <rect width="20" height="18.0035" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Settings
                </Dropdown.Item> */}
                <Dropdown.Item onClick={removeToken}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_1_77)">
                      <path
                        d="M6.91406 20H6.40625C6.28906 19.9633 6.17188 19.9281 6.05742 19.8898C4.43281 19.3496 2.80703 18.8121 1.18398 18.2664C0.571484 18.0602 0.182421 17.6383 0.0359368 17.002C0.0263552 16.9717 0.0143372 16.9423 0 16.9141V1.40625C0.0164062 1.35898 0.0347652 1.31211 0.0484371 1.26406C0.210937 0.688021 0.572916 0.295964 1.13437 0.0878906C1.22383 0.0550781 1.31562 0.0292969 1.40781 0H11.1344C11.1836 0.0132813 11.2324 0.0308594 11.2824 0.0390625C12.366 0.229297 13.2746 1.19414 13.3137 2.26562C13.3488 3.19531 13.327 4.12695 13.3242 5.0582C13.3242 5.3 13.2094 5.49766 13.0223 5.64609C12.7594 5.85469 12.4637 5.89336 12.1598 5.75742C11.8473 5.61758 11.675 5.3668 11.6727 5.01992C11.6664 4.21953 11.6703 3.41836 11.6691 2.61797C11.6691 2.00313 11.3418 1.67227 10.734 1.67148C9.57487 1.67148 8.41601 1.67148 7.25742 1.67148C7.20117 1.67148 7.14492 1.67656 7.08203 1.6793C7.0957 1.69961 7.1 1.71367 7.10859 1.71836C8.0207 2.10469 8.3293 2.57109 8.32969 3.56289V15.8301H10.7031C11.3504 15.8301 11.6676 15.5086 11.668 14.8535C11.668 13.8249 11.668 12.7962 11.668 11.7676C11.6642 11.6572 11.6746 11.5468 11.6988 11.4391C11.8027 11.0523 12.1875 10.7914 12.5707 10.8359C13.0055 10.8863 13.3195 11.2082 13.3227 11.6426C13.331 12.7559 13.3318 13.8691 13.325 14.9824C13.3152 16.4141 12.2227 17.4941 10.791 17.4988C10.0422 17.5012 9.29375 17.4988 8.54492 17.4988H8.32305C8.32305 17.8211 8.33125 18.1133 8.32305 18.4051C8.30508 18.925 8.08867 19.3578 7.66367 19.652C7.4418 19.809 7.16602 19.8871 6.91406 20Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                      <path
                        d="M19.9999 8.51564C19.8484 8.72189 19.7191 8.95001 19.5413 9.13087C18.5269 10.1606 17.4999 11.1762 16.48 12.2004C16.2593 12.4219 16.0046 12.5422 15.6894 12.4856C15.2753 12.4113 15.0031 12.0762 15.0011 11.6383C14.9976 10.8961 15.0011 10.1539 15.0011 9.41173V9.16954H14.7656C13.7566 9.16954 12.7476 9.16954 11.7386 9.16954C11.2734 9.16954 10.9371 8.90939 10.855 8.49962C10.7488 7.96798 11.1347 7.50352 11.6953 7.50157C12.7171 7.49767 13.739 7.50157 14.7613 7.50157H14.9999V7.28595C14.9999 6.5504 15.0031 5.81485 14.9999 5.0793C14.9976 4.68868 15.1503 4.38907 15.514 4.23789C15.8777 4.08672 16.1984 4.18516 16.4745 4.46211C17.5546 5.54532 18.6398 6.62305 19.7148 7.71134C19.8378 7.83595 19.907 8.0129 20.0011 8.16564L19.9999 8.51564Z"
                        fill="#101D42"
                        fillOpacity="0.5"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_77">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </nav>
      <Modal
        show={show}
        onHide={handleClose}
        className="SubmitPopup howitworks"
      >
        <Modal.Header closeButton className="justify-content-center border-0">
          <Modal.Title>
            <h2 className="h2_medum fw-bold text-center pt-4 mb-0">
              How It
              <span className="color-9F7854 user-name fw-bold"> Works</span>
            </h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="mb-0">
            <li>
              At KBD, you can list a business or request a business listing.{" "}
            </li>
            <li>The first step is to sign up for the platform. </li>
            <li>
              The platform requires proof of identity from its members, which
              the admin verifies.
            </li>
            <li>
              For further verification, you are requested to add two community
              references.{" "}
            </li>
            <li>
              Once you are approved, you can now list a business and request a
              business listing in up to 3 categories.{" "}
            </li>
            <li>
              All requests, including signup, listing a business, and requesting
              a listing, are verified and approved by an admin.{" "}
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer
          style={{ justifyContent: "center" }}
          className="text-center pb-5"
        >
          Sign up <span>{">"}</span> Get approved by the admin{" "}
          <span>{">"}</span> Sign in <span>{">"}</span> List a business{" "}
          <span>{">"}</span> Approved by admin and added to the directory{" "}
          <span>{">"}</span> Request a business listing <span>{">"}</span>{" "}
          Approved by admin and listing emailed to the member
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default Header2;